import type { BaseCommandSubmission } from '@festina-life/authentication'
import type { CommandActionVariant } from '@festina-life/ui/theme'
import { useMemo } from 'react'

import type { CommandSubmissionData } from '../components/commandActions/commandPalette/CommandPaletteModalButton'
import type {
  ActionData,
  AnyCommandVersion,
} from '../components/commandActions/types'

export type CommandSubmissionWarnings = {
  create?: ActionData['status']['warnings']
  cancel?: ActionData['status']['warnings']
  update?: ActionData['status']['warnings']
  approve?: ActionData['status']['warnings']
  approvePendingCancellation?: ActionData['status']['warnings']
  declinePendingCancellation?: ActionData['status']['warnings']
}

export const useVariantAction = <T extends AnyCommandVersion['commandData']>({
  commandActionVariant,
  actions,
}: {
  commandActionVariant: CommandActionVariant
  actions: BaseCommandSubmission<T>
}): CommandSubmissionData<T> | undefined =>
  useMemo(() => {
    if (commandActionVariant === 'read') {
      return undefined
    }

    const action = actions[commandActionVariant]

    if (!action) {
      return
    }

    return {
      onSubmit: action.mutateAsync,
      authorization: action?.authorization,
    } satisfies CommandSubmissionData<T>
  }, [actions, commandActionVariant])
